import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/placeholder/haircut.jpg'
import _imports_1 from '@/assets/placeholder/skincare.jpg'
import _imports_2 from '@/assets/placeholder/bridal.jpg'


const _hoisted_1 = { class: "home-view" }
const _hoisted_2 = { class: "hero-section" }
const _hoisted_3 = { class: "hero-content" }
const _hoisted_4 = { class: "about-snippet-section section-padding" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "services-highlight-section section-padding" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "offers-section section-padding" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "offers-carousel-wrapper" }
const _hoisted_11 = { class: "cta-section section-padding" }
const _hoisted_12 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_OfferCard = _resolveComponent("OfferCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("h1", null, "Attractive Unisex Salon – Beauty & Style in Gondia", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "hero-subtitle" }, "Your journey to a more confident and attractive you begins here.", -1)),
        _createVNode(_component_router_link, {
          to: "/services",
          class: "btn btn-primary btn-large"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Explore Our Services")
          ])),
          _: 1,
          __: [2]
        }),
        _createVNode(_component_router_link, {
          to: "/book-appointment",
          class: "btn btn-secondary btn-large"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("Book Appointment")
          ])),
          _: 1,
          __: [3]
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "section-title" }, "Welcome to Attractive Unisex Salon", -1)),
        _cache[8] || (_cache[8] = _createElementVNode("p", null, " Step into a world of relaxation and transformation. At Attractive Unisex Salon, we are dedicated to providing top-notch hair, skin, and beauty services tailored to your unique style and preferences. Our team of experienced professionals is passionate about making you look and feel your best. ", -1)),
        _createVNode(_component_router_link, {
          to: "/about",
          class: "btn btn-outline"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode("Learn More About Us")
          ])),
          _: 1,
          __: [6]
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[10] || (_cache[10] = _createStaticVNode("<h2 class=\"section-title\" data-v-c8fa7b58>Our Popular Services</h2><div class=\"services-grid\" data-v-c8fa7b58><div class=\"service-card\" data-v-c8fa7b58><div class=\"service-card-image-container\" data-v-c8fa7b58><img src=\"" + _imports_0 + "\" alt=\"Professional haircut and styling at Attractive Salon Gondia\" loading=\"lazy\" width=\"400\" height=\"300\" data-v-c8fa7b58></div><div class=\"service-card-content\" data-v-c8fa7b58><h3 data-v-c8fa7b58>Hair Styling &amp; Cuts</h3><p data-v-c8fa7b58>Modern cuts, vibrant colors, and elegant styling for all occasions.</p></div></div><div class=\"service-card\" data-v-c8fa7b58><div class=\"service-card-image-container\" data-v-c8fa7b58><img src=\"" + _imports_1 + "\" alt=\"Revitalizing skincare facial treatment at Attractive Salon Gondia\" loading=\"lazy\" width=\"400\" height=\"300\" data-v-c8fa7b58></div><div class=\"service-card-content\" data-v-c8fa7b58><h3 data-v-c8fa7b58>Revitalizing Skin Care</h3><p data-v-c8fa7b58>Facials, treatments, and therapies to rejuvenate your skin.</p></div></div><div class=\"service-card\" data-v-c8fa7b58><div class=\"service-card-image-container\" data-v-c8fa7b58><img src=\"" + _imports_2 + "\" alt=\"Bridal and special occasion makeup at Attractive Salon Gondia\" loading=\"lazy\" width=\"400\" height=\"300\" data-v-c8fa7b58></div><div class=\"service-card-content\" data-v-c8fa7b58><h3 data-v-c8fa7b58>Bridal &amp; Special Occasions</h3><p data-v-c8fa7b58>Look stunning on your special day with our expert makeup artists.</p></div></div></div>", 2)),
        _createVNode(_component_router_link, {
          to: "/services",
          class: "btn btn-primary"
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode("View All Services")
          ])),
          _: 1,
          __: [9]
        })
      ])
    ]),
    _cache[15] || (_cache[15] = _createStaticVNode("<section class=\"testimonials-section section-padding\" data-v-c8fa7b58><div class=\"container\" data-v-c8fa7b58><h2 class=\"section-title\" data-v-c8fa7b58>What Our Clients Say</h2><div class=\"testimonial-grid\" data-v-c8fa7b58><div class=\"testimonial-card\" data-v-c8fa7b58><p data-v-c8fa7b58>&quot;Absolutely loved my new haircut! The stylists are so talented and friendly. Highly recommend!&quot;</p><h4 data-v-c8fa7b58>- Priya S.</h4></div><div class=\"testimonial-card\" data-v-c8fa7b58><p data-v-c8fa7b58>&quot;The best facial I&#39;ve ever had. My skin feels amazing. Will definitely be back.&quot;</p><h4 data-v-c8fa7b58>- Rohan M.</h4></div><div class=\"testimonial-card\" data-v-c8fa7b58><p data-v-c8fa7b58>&quot;Got my bridal makeup done here and it was flawless. They made me feel like a princess!&quot;</p><h4 data-v-c8fa7b58>- Aisha K.</h4></div></div></div></section>", 1)),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "section-title" }, "Current Offers", -1)),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.offers.length > 3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollOffers(-1))),
                class: "carousel-control prev",
                "aria-label": "Previous Offer"
              }, "←"))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["offers-carousel", { 'is-centered': _ctx.offers.length <= 3 }]),
            ref: "offersCarousel"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offers, (offer) => {
              return (_openBlock(), _createBlock(_component_OfferCard, {
                key: offer.id,
                offer: offer
              }, null, 8, ["offer"]))
            }), 128))
          ], 2),
          (_ctx.offers.length > 3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollOffers(1))),
                class: "carousel-control next",
                "aria-label": "Next Offer"
              }, "→"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _cache[16] || (_cache[16] = _createElementVNode("section", { class: "contact-map-section section-padding" }, [
      _createElementVNode("div", { class: "container" }, [
        _createElementVNode("h2", { class: "section-title" }, "Visit Us or Get in Touch"),
        _createElementVNode("div", { class: "contact-map-grid" }, [
          _createElementVNode("div", { class: "contact-details" }, [
            _createElementVNode("h3", null, "Our Address"),
            _createElementVNode("p", null, [
              _createTextVNode(" Attractive Unisex Salon and Academy"),
              _createElementVNode("br"),
              _createTextVNode(" Near Ayush Hospital, Rail Toly,"),
              _createElementVNode("br"),
              _createTextVNode(" Gondia, Maharashtra 441614, India ")
            ]),
            _createElementVNode("h3", null, "Contact Us"),
            _createElementVNode("p", null, [
              _createTextVNode(" Phone: "),
              _createElementVNode("a", { href: "tel:+918446607478" }, "+91-844-660-7478"),
              _createTextVNode(),
              _createElementVNode("br"),
              _createTextVNode(" Email: "),
              _createElementVNode("a", { href: "mailto:attractiveunisexsalon@gmail.com" }, "attractiveunisexsalon@gmail.com")
            ])
          ]),
          _createElementVNode("div", { class: "map-container" }, [
            _createElementVNode("iframe", {
              src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1402.7598485247859!2d80.19206499929479!3d21.46434031933013!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a2baf46f01b6aa3%3A0x8d02e3d2cc378918!2sThe%20Attractive%20Unisex%20salon%20and%20Academy!5e0!3m2!1sen!2sin!4v1750080347192!5m2!1sen!2sin",
              width: "100%",
              height: "350",
              style: {"border":"0"},
              allowfullscreen: "",
              loading: "lazy",
              referrerpolicy: "no-referrer-when-downgrade"
            })
          ])
        ])
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "section-title-light" }, "Ready for a Makeover?", -1)),
        _cache[14] || (_cache[14] = _createElementVNode("p", null, "Contact us today to schedule your appointment or consult with our beauty experts.", -1)),
        _createVNode(_component_router_link, {
          to: "/book-appointment",
          class: "btn btn-gold btn-large"
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [
            _createTextVNode("Book Your Appointment Now")
          ])),
          _: 1,
          __: [12]
        })
      ])
    ])
  ]))
}